<template>
  <div style="display: flex; flex-direction: column;height: 100vh;position: relative;" :style="{background:type==='0' ? '#F0F8FD' : '#F1F8F2'}">
    <div class="dialog-content" id="dialogContent" v-if="!imagePosterUrl">
      <img style="width: 100%;height: 100vh;" :src="mainPosterImg" crossOrigin="anonymous"/>
      <div style="position: absolute;bottom: 10px;left: 20px;">
        <vue-qr
            class="qrCode"
            ref="qrCode"
            :text="qrCode.text"
            :logoSrc="qrCode.logoSrc"
            :color-dark="qrCode.randomColor"
            :callback="qrCodeCallback"

        ></vue-qr>
      </div>
    </div>

    <div class="dialog-content" v-else>
      <img style="width: 100%;height: 100vh;" :src="imagePosterUrl" />
    </div>

    <div class="btn" @click="saveImgShare" :class="imagePosterUrl?'btn-default':'btn-primary'">{{confirmBtnTxt}}</div>

  </div>
</template>

<script>
import Cookies from "js-cookie";
import VueQr from 'vue-qr'
import html2canvas from "html2canvas";
import {Toast} from "vant";

export default {
  name: "SharePoster",
  components: {
    VueQr,
    html2canvas
  },
  data() {
    return {
      type: Cookies.get('type'),
      user: this.$store.state.user.user,
      id: this.$route.query.id || localStorage.getItem("detailProductId") || '',
      mainPosterImg: this.$route.query.mainPosterImg,

      confirmBtnTxt:'生成分享图片',
      longPressTimer: null, // 用于存储长按定时器的引用
      imagePosterUrl: '',
      qrCode:{
        text:'',
        logoSrc: "https://yibaoobj.oss-cn-shanghai.aliyuncs.com/test/20240907/063098a178dbeb62a9eecbc59fdb0722.png", // 二维码中间的图片
        randomColor: 'black', // 二维码颜色

      }
    }
  },
  created() {
    let url = process.env.VUE_APP_SHARE_URL + `/custProductDetail?id=${this.id}&type=${this.type}` + '&shareId=' + this.$store.state.user.user.userId
    this.qrCode.text = url
  },
  methods:{
    saveImgShare(){
      if(this.imagePosterUrl){
        this.$toast({message: '请长按图片保存分享图片。', duration: 1500});
        return;
      }
    /*  Toast.loading({
        mask: true,
        message: '生成海报中...'
      });*/

      const content = document.getElementById("dialogContent");
      html2canvas(content, {
        useCORS: true,// 使用 CORS 模式加载资源
        allowTaint: false, // 禁止加载被污染的图像
        scale: 2// 设置 scale 提高清晰度
      })
          .then((canvas) => {
            // 将 Canvas 转换为图片 URL
            const imageUrl = canvas.toDataURL("image/png");
            this.imagePosterUrl = imageUrl;
            this.confirmBtnTxt = "长按图片保存海报图片";

         /*   Toast.clear();
            this.$toast({message: '海报已生成，请长按图片保存海报。', duration: 1500});
*/
          })
          .catch((error) => {
            console.error("截图失败：", error);
          });
    },

    qrCodeCallback(url){
      // console.log(url,">>>")
    },

    handleTouchStart(event) {
      // 清除之前的定时器（如果有的话）
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
      }

      // 设置定时器，等待一定时间（如500ms）来判断是否为长按
      this.longPressTimer = setTimeout(() => {

      }, 500);

      // 阻止默认行为（可选，根据需要）
      event.preventDefault();
    },

    handleTouchEnd(event) {
      // 清除定时器，防止长按被触发
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },

    handleTouchCancel(event) {
      // 清除定时器（如果触摸被取消）
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
    },
  }
}
</script>

<style scoped>

.btn{
  position: absolute;
  bottom: 0;
  margin-top: 10px;
  width: 100%;
  text-align: center;
  height: 30px;
  line-height: 30px;
}
.btn-primary{
  color: #FFFFFF;
  background: #1987F5;
}
.btn-default{
  color: #656A7B;
  background: #FFFFFF;
}



.dialog-content{
  width: 95vw;
  position: relative;
  height: calc(100vh - 30px);
}
.qrCode{
  width: 100px;
  height: 100px;
}

/* iphone8 */
@media screen and (max-height: 670px) {
  .qrCode{
    width: 90px;
    height: 90px;
  }
}
</style>
